var map = {
	"./IMAGE.png": 5114,
	"./PDF.png": 4079,
	"./PPT.png": 2558,
	"./RAR.png": 8502,
	"./TXT.png": 8519,
	"./Word.png": 3752,
	"./Zip.png": 1225,
	"./cut-off-rule.png": 1494,
	"./icon-line.png": 3843,
	"./mp3.png": 7100,
	"./mp4.png": 9542,
	"./other.png": 7858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 519;